<div class="content">
  <table mat-table [dataSource]="dataSource">
    <!-- Name column -->
    <ng-container matColumnDef="name">
      <th
        [ngClass]="this.supportingParty() ? 'header-with-border' : 'header-with-border-primary'"
        mat-header-cell
        *matHeaderCellDef
      >Naam</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <mat-form-field class="full-width">
          <input placeholder="Volledige naam" matInput [formControl]="row.controls.name">
        </mat-form-field>
        @if (error(row.controls.name, 'required')) {
          <mat-error>Vul a.u.b een volledige naam in</mat-error>
        }
      </td>
    </ng-container>

    <!-- Supporting party column -->
    <ng-container matColumnDef="organisation">
      <th
        [ngClass]="this.supportingParty() ? 'header-with-border' : 'header-with-border-primary'"
        mat-header-cell
        *matHeaderCellDef
      >Organisatie</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <mat-form-field class="full-width">
          <input placeholder="Naam organisatie" matInput [formControl]="row.controls.organisation">
        </mat-form-field>
        @if (error(row.controls.organisation, 'required')) {
          <mat-error>Vul a.u.b een organisatie naam in</mat-error>
        }
      </td>
    </ng-container>

    <!-- Email column -->
    <ng-container matColumnDef="email">
      <th
        [ngClass]="this.supportingParty() ? 'header-with-border' : 'header-with-border-primary'"
        mat-header-cell
        *matHeaderCellDef
      >E-mailadres</th>
      <td mat-cell *matCellDef="let row; let i = index">
        @if (row.controls.ssoId.defaultValue === '') {
          <mat-form-field class="full-width">
            <input placeholder="voorbeeld@voorbeeld.nl" matInput [formControl]="row.controls.email">
          </mat-form-field>
        } @else {
          <span>{{row.controls.email.defaultValue}}</span>
        }
        @if (error(row.controls.email, 'required')) {
          <mat-error>Vul a.u.b een e-mail in</mat-error>
        }
        @if (error(row.controls.email, 'pattern')) {
          <mat-error>Vul a.u.b een geldig e-mail adres in</mat-error>
        }
      </td>
    </ng-container>

    <!-- Action column -->
    <ng-container matColumnDef="action">
      <th
        [ngClass]="this.supportingParty() ? 'header-with-border' : 'header-with-border-primary'"
        mat-header-cell
        *matHeaderCellDef
      ></th>
      <td mat-cell *matCellDef="let row; let i = index">
        <div class="circle" (click)="removeInput(i)">
          <button class="accessibility-button">
            <mat-icon class="circle-icon" aria-hidden="false" aria-label="Rij verwijderen" fontIcon="delete"></mat-icon>
          </button>
        </div>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      [ngClass]="this.supportingParty() ? 'row' : 'row-primary'"
      mat-row
      *matRowDef="let row; index as i; columns: displayedColumns;"
    ></tr>
  </table>
  <button mat-button color="primary" (click)="addInput()">+ Rij toevoegen</button>
</div>